export function clickActionArgs(name, controlType, locationInPage, URL) {
	const baseArgs = {
		web: {
			webInteraction: {
				name,
				type: 'other'
			},
			_etassureco: {
				controlType
			}
		},
		siteKnowledge: {
			supportSiteSearch: {
				locationInPage
			}
		}
	};

	if (URL) {
		baseArgs.web.webInteraction.URL = URL;
	}

	return baseArgs;
}

export function pageViewArgs(name, siteSection, isHomePage = false, isErrorPage = false) {
	return {
		web: {
			webPageDetails: {
				name,
				siteSection,
				isHomePage,
				isErrorPage
			}
		}
	};
}
